import React, { useState } from "react";
import CloseIcon from ".//..//..//..//assets//images//icons//close.svg";

const ModalCenter = ({
  isOpen,
  closeModal,
  children,
  header = "",
  isDisabled = false,
}) => {
  return (
    <>
      <div
        className={`fixed w-full z-[100]  top-0 left-0 h-screen 
       p-4 bg-[#d9d9d980] backdrop-blur-[0.625rem] ${
         isOpen === true ? "flex" : "hidden"
       }`}
      ></div>

      <div
        className={`fixed w-full z-[120] h-full max-h-[75vh] -translate-x-1/2 -translate-y-1/2  top-1/2 left-1/2  overflow-y-auto 
       justify-center items-center max-w-[55rem]  mt-[10rem] sm:mt-0 bg-white h- rounded-[1rem]  ${
         isOpen === true ? "flex" : "hidden"
       }`}
      >
        <div className="absolute w-full h-full p-7 sm:p-10 ">
          <header className="grid grid-cols-[1fr_4rem] items-center gap-3 mb-10">
            <h2 className="font-poppins font-semibold text-left leading-normal text-text-primary-color text-[2.5rem]">
              {header}
            </h2>
            <button
              disabled={isDisabled}
              onClick={isDisabled ? () => {} : closeModal}
            >
              <img
                src={CloseIcon}
                className="w-[2rem] sm:w-[3.125rem]   right-10 ms-auto cursor-pointer"
              />
            </button>
          </header>
          <main className="pb-10 mt-3 text-start">{children}</main>
        </div>
      </div>
    </>
  );
};

export default ModalCenter;
